import { Col, Radio, Row } from "antd";

const RadioListItem = (props) => {
  const {
    label,
    imgSrc,
    disabled,
    labelClass,
    emptyLabelClass,
    value: optionValue,
  } = props;

  const isString = typeof label === "string";

  return (
    <Radio
      value={optionValue}
      className={` ${disabled ? "disabled-item" : ""}`}
      disabled={disabled}
    >
      <Row
        className={`radio-label-container ${
          isString && !emptyLabelClass ? label.toLowerCase() : ""
        }`}
      >
        <Col md={24} sm={24} xs={24}>
          <div className={`flex align-center ${labelClass || ""}`}>
            {imgSrc && (
              <span className="radio-info-img">
                <img src={imgSrc} alt={label} />
              </span>
            )}
            {label}
          </div>
        </Col>
      </Row>
    </Radio>
  );
};

export default RadioListItem;
